import React from "react";
import { Modal, Button } from "react-bootstrap";
import { EditOutlined } from "../../../../helpers/icons/antDesignIcons";

const SettingsLocationMoreInfoModal = ({
  show,
  onClose,
  locationInfo,
  onEditLocation,
  t, // Translation function
}) => {
  // Function to format the address due to users filling out only the site city field
  const formatAddress = (locationInfo) => {
    const { zip, sitecity, sitestreet, sitehousenr } = locationInfo;
    let address = sitecity || "N/A";

    if (zip) {
      address = `${zip} ${address}`;
    }

    if (sitestreet) {
      address = `${address}, ${sitestreet}`;
    }

    if (sitehousenr) {
      address = `${address} ${sitehousenr}`;
    }

    return address;
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      className="csl-modal"
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>{locationInfo?.sitename || "N/A"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {t("address")}: {formatAddress(locationInfo)}
        </p>
        <p>
          {t("containerCount")}: {locationInfo?.container_count || 0}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => onEditLocation(locationInfo)}>
          <EditOutlined /> {t("edit")}
        </Button>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SettingsLocationMoreInfoModal;
